export const NO_CONTENT_MESSAGE = '(no content)'
